import React from "react";
import { DateRangePicker } from "react-date-range";
import { DefaultFooter } from "../../container/default-layout/footer";
import DefaultHeader from "../../container/default-layout/header";
import DefaultSideBar from "../../container/default-layout/side.bar";
import { InputRanges, getDaysUpToTodayRange } from "../../../constants/dateRanges";
import Select from "react-select";
import {
  ALL_REPORT_TYPES,
  ROLE_SUPER_ADMIN,
  ROLE_CLIENT_ADMIN,
} from "../../../constants/index";
import Loader from "../../../components/loader";
import AppService from "../../../services/app.service";
import auth from "../../../services/auth";
import $ from "jquery";
import { connect } from "react-redux";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { formatDateToString } from "../../../utils/dateUtils";
import AlertDialogSlide from "../../../components/deleteModal";
import { Checkbox, FormGroup } from "@material-ui/core";
import {
  findAccountByValue,
  selectAllAccounts,
  selectAllSimulations,
  selectAllSimulationByAccount,
  selectAllRegions,
  selectAllEmails,
  handleMultiSelectChange,
  getMultiSelectOptions,
  isWithinAllowedDays,
} from "../../../utils/utils";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import QuadrimesterTextField, {
  ENABLE_CURRENT_QUADRIMESTER_SELECTION_FOR_TESTING,
  snapshotDateFieldSx,
} from "./QuadrimesterTextField";
import {
  DEDICATED_REPORT_ENDPOINTS,
  LEGACY_GENERATE_URL,
} from "./reportPayloads";

import {
  reportNames,
  feildSelectionMessage,
} from "../../../constants/stringConstants";
import { reportMessages } from "../../../constants/errorMessages";
import { extractApiMessage } from "../../../utils/apiError";
import axios from "axios";
import { cohortReports } from "../../../utils/utils";
import { showErrorMessage } from "../../../components/ShowFeildValidationError";
import { Reports, ROLE_REPORT_GEN_LIMIT } from "../../../utils/constants";
import ParticipantsFilter from "../../../components/ParticipantsFilter";
import GenericMultiSelectField from "../../../components/GenericMultiSelectField";
import dayjs from "dayjs";

const QUADRIMESTERS = [
  { startMonth: 1, endMonth: 4, label: "Jan - Apr" },
  { startMonth: 5, endMonth: 8, label: "May - Aug" },
  { startMonth: 9, endMonth: 12, label: "Sep - Dec" },
];

function quadrimesterForMonth(monthNumber) {
  return QUADRIMESTERS.find(
    (period) => monthNumber >= period.startMonth && monthNumber <= period.endMonth
  );
}

/** True while this quadrimester still includes the current month or a later one. */
function quadrimesterIsStillOpen(year, endMonth) {
  const now = dayjs();
  if (year > now.year()) {
    return true;
  }
  if (year < now.year()) {
    return false;
  }
  return now.month() + 1 <= endMonth;
}

class Report extends React.Component<any, any> {
  getAvailableReportTypes = (
    isTeacherSimsEligibleForClientAdmin = true,
    userRole = this.state?.userRole,
    accType = auth?.getUserDetails()?.accType
  ) => {
    return ALL_REPORT_TYPES.filter((report) => {
      if (!report.role.includes(userRole)) {
        return false;
      }

      if (
        userRole === ROLE_CLIENT_ADMIN &&
        report.hasDate?.restrictToNonHigherEd &&
        accType === "Higher Ed"
      ) {
        return false;
      }

      if (userRole === ROLE_CLIENT_ADMIN) {
        const isStandardSummaryReport =
          report.label === reportNames.onDemandCaepSimulationSummaryReport ||
          report.label ===
            reportNames.monthlySnapshotCaepSimulationSummaryReport ||
          report.label === reportNames.onDemandAaqepSimulationSummaryReport ||
          report.label ===
            reportNames.quadrimestralSnapshotAaqepSimulationSummaryReport ||
          report.label ===
            reportNames.onDemandNelpPselStandardSummaryReport ||
          report.label ===
            reportNames.quadrimestralSnapshotNelpPselStandardSummaryReport;
        if (isStandardSummaryReport && !isTeacherSimsEligibleForClientAdmin) {
          return false;
        }
      }

      return true;
    });
  };

  constructor(props) {
    super(props);
    const userRole =
      props.user.userDetail.accId > 0 ? ROLE_CLIENT_ADMIN : ROLE_SUPER_ADMIN;
    const accType = auth?.getUserDetails()?.accType;

    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      accountCreatedDate: null,
      report: "",
      selectedReportType: [],
      simulations: [],
      simulationsList: [],
      errorMsg: {
        report: "",
        simulations: "",
        accounts: "",
        simulationsByAccount: "",
        accountFilteration: "",
        emails: "",
        cohort: "",
        accountSingleSelect: "",
        filterByParticipant: "",
        filterByModifiedParticipant: "",
        dateRange: "",
        monthErrorText: "",
        periodErrorText: "",
      },
      reportTypes: this.getAvailableReportTypes(true, userRole, accType),
      acc: [],
      region: [],
      accList: [],
      singleSelectAccountList: [],
      accountList: [],
      account: props.user.userDetail.accId,
      numPages: null,
      pageNumber: 1,
      user: props.user,
      userRole: userRole,
      reportGenType: "pdf",
      accountCreatedDateErrorState: false,
      isShowingModal: false,
      simulationsByAccount: [],
      simulationsListByAccount: [],
      accountAsList: [],
      simsAsList: [],
      regionList: [],
      sortBy: { sortBySim: false, sortByAccount: false },
      filterBy: { activeFilter: true, inActiveFilter: false },
      filterByParticipant: { activeFilter: true, inActiveFilter: false },
      filterByModifiedParticipant: {
        activeFilter: true,
        inActiveFilter: false,
      },
      activeAccounts: [],
      inActiveAccounts: [],
      manuallySelectedAccounts: false,
      manuallyRemovedAccounts: [],
      activeAccMultiSelect: [],
      inActiveAccMultiSelect: [],
      isAllAccounts: false,
      emails: [],
      emailList: [],
      cohortList: [],
      selectedCohort: "",
      cohortAccountList: [],
      originalAccountList: [],
      teacherSimsEligibleList: [],
      dateValue: null,
      monthSelector: null,
      selectedPeriod: null,
      selectedPeriodPickerValue: null,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (state.user !== props.user) {
      return {
        user: props.user,
      };
    }
    return null;
  }

  applyReportFromQuery = (reportTypes = this.state.reportTypes) => {
    const search =
      this.props.location?.search ||
      (typeof window !== "undefined" ? window.location.search : "");
    const params = new URLSearchParams(search);
    const reportValue = params.get("report");
    if (!reportValue) return;

    const selected = reportTypes.find((report) => report.value === reportValue);
    if (!selected) return;

    this.handleReportChanged(selected);

    const days = parseInt(params.get("days") || "", 10);
    if (Number.isFinite(days) && days > 0) {
      const dateRange = getDaysUpToTodayRange(days);
      this.setState({
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
      });
    }
  };

  updateClientAdminReportTypes = async () => {
    let reportTypes = this.state.reportTypes;
    if (this.state.userRole === ROLE_CLIENT_ADMIN) {
      try {
        const accountId = auth.getUserDetails().accId;
        const eligibilityResp = await AppService.getAll(
          `accounts/isTeacherSimsEligible/${accountId}`
        );
        const isTeacherSimsEligible =
          eligibilityResp?.data?.teacherSimsEligible === true;
        reportTypes = this.getAvailableReportTypes(isTeacherSimsEligible);
        this.setState({ reportTypes });
      } catch (error) {
        // Hide CAEP reports for Client Admin if eligibility check fails.
        reportTypes = this.getAvailableReportTypes(false);
        this.setState({ reportTypes });
      }
    }
    this.applyReportFromQuery(reportTypes);
  };

  componentDidMount() {
    this.updateClientAdminReportTypes();
    this.loadData();
  }

  cohortProgressReports = [
    cohortReports.cohortProgressReportLabel,
    cohortReports.wellnessReportLabel,
    cohortReports.jobConfidenceReportLabel,
  ];

  isCohortRelatedReportChanged = (prevState) => {
    return (
      !this.cohortProgressReports.includes(prevState.report) &&
      this.cohortProgressReports.includes(this.state.report)
    );
  };

  isNotCohortRelatedReportChanged = (prevState) => {
    return (
      this.cohortProgressReports.includes(prevState.report) &&
      !this.cohortProgressReports.includes(this.state.report)
    );
  };

  isCohortReportAndAccIdChanged = (prevState) => {
    return (
      this.cohortProgressReports.includes(prevState.report) &&
      this.cohortProgressReports.includes(this.state.report) &&
      prevState.accId !== this.state.accId
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location?.search !== this.props.location?.search) {
      this.applyReportFromQuery();
    }

    const isCohortRelatedReport = this.isCohortRelatedReportChanged(prevState);

    if (isCohortRelatedReport) {
      this.setState({
        singleSelectAccountList: this.state.cohortAccountList,
        accounts: "",
      });
      if (auth.getUserDetails().roleName == "Role_Admin") {
        this.setState({
          accId: auth.getUserDetails().accId,
          accounts: auth.getUserDetails().accId,
        });
      }
    }

    const isNotCohortRelatedReport =
      this.isNotCohortRelatedReportChanged(prevState);

    if (isNotCohortRelatedReport) {
      this.setState({
        accounts: this.state.accList[0],
        singleSelectAccountList: this.state.accList,
      });
    }

    if (this.isCohortReportAndAccIdChanged(prevState)) {
      this.setState({ selectedCohort: "" });
    }
  }

  handleReportChanged = (selectedOption) => {
    this.setState({
      selectedReportType: selectedOption,
      report: selectedOption.label,
      reportGenType:
        this.state.selectedReportType.hasDate?.bothSelectionType &&
        this.state.reportGenType == "both"
          ? "pdf"
          : this.state.reportGenType,
      errorMsg: {
        report: "",
        simulations: this.state.errorMsg.simulations,
        accounts: this.state.errorMsg.accounts,
        cohort: this.state.errorMsg.cohort,
        accountSingleSelect:
          selectedOption.value === "cohortProgressReport"
            ? this.state.errorMsg.accountSingleSelect
            : "",
        filterByParticipant: this.state.errorMsg.filterByParticipant,
        filterByModifiedParticipant:
          this.state.errorMsg.filterByModifiedParticipant,
        dateRange: "",
        monthErrorText: '',
        periodErrorText: '',
      },
      accountCreatedDate: null,
      accountCreatedDateErrorState: false,
      monthSelector: null,
      selectedPeriod: null,
      selectedPeriodPickerValue: null,
    });
    if (selectedOption.hasDate?.selectionTypeExcelOnly) {
      this.setState({ reportGenType: "xls" });
    }

    const isStandardSummaryReport =
      selectedOption.label ===
        reportNames.onDemandCaepSimulationSummaryReport ||
      selectedOption.label ===
        reportNames.monthlySnapshotCaepSimulationSummaryReport ||
      selectedOption.label ===
        reportNames.onDemandAaqepSimulationSummaryReport ||
      selectedOption.label ===
        reportNames.quadrimestralSnapshotAaqepSimulationSummaryReport ||
      selectedOption.label ===
        reportNames.onDemandNelpPselStandardSummaryReport ||
      selectedOption.label ===
        reportNames.quadrimestralSnapshotNelpPselStandardSummaryReport;

    if (isStandardSummaryReport) {
      const eligible =
        this.state.userRole === ROLE_SUPER_ADMIN
          ? this.state.teacherSimsEligibleList
          : this.state.originalAccountList;
      const activeEligible = eligible.filter(
        (obj) => obj.active === "Active"
      );
      const inActiveEligible = eligible.filter(
        (obj) => obj.active === "InActive"
      );
      const activeEligibleWithAll = [
        { value: 0, label: "All" },
        ...activeEligible,
      ];
      this.setState({
        accountList: eligible,
        activeAccMultiSelect: activeEligible,
        inActiveAccMultiSelect: inActiveEligible,
        accList: activeEligibleWithAll,
        activeAccounts: activeEligibleWithAll,
        singleSelectAccountList: activeEligibleWithAll,
        acc: [],
        isAllAccounts: false,
      });
    } else {
      const original = this.state.originalAccountList;
      const activeOriginal = original.filter(
        (obj) => obj.active === "Active"
      );
      const inActiveOriginal = original.filter(
        (obj) => obj.active === "InActive"
      );
      const activeOriginalWithAll = [
        { value: 0, label: "All" },
        ...activeOriginal,
      ];
      this.setState({
        accountList: original,
        activeAccMultiSelect: activeOriginal,
        inActiveAccMultiSelect: inActiveOriginal,
        accList: activeOriginalWithAll,
        activeAccounts: activeOriginalWithAll,
        singleSelectAccountList: activeOriginalWithAll,
        acc: [],
        isAllAccounts: false,
      });
    }
  };

  handleDateRangeChanged = async (ranges) => {
    this.setState({
      errorMsg: {
        dateRange: "",
      },
    });

    this.setState({
      startDate: ranges.range1.startDate,
      endDate: ranges.range1.endDate,
    });
  };

  handleChangeForShowingModal = () => this.setState({ isShowingModal: false });

  generateReport = async () => {
    $("#reportDiv").empty();
    const reportCheck = this.state.report === "";
    const simulationsCheck =
      this.state.simulations.length === 0 &&
      this.state.selectedReportType.hasDate?.simSelection;
    const accountCheck =
      this.state.acc.length === 0 &&
      this.state.selectedReportType.hasDate?.multipleAccountSelection;
    const cohortCheck =
      this.state.selectedCohort === "" &&
      this.state.selectedReportType.hasDate?.cohortSelection;
    const accountSingleCheck =
      this.state.accounts === "" &&
      this.state.selectedReportType.hasDate?.cohortSelection;
    const simulationsCheckByAccountCheck =
      this.state.simulationsByAccount.length === 0 &&
      this.state.selectedReportType.hasDate?.simSelection;
    const filterCheck =
      !this.state.filterBy.activeFilter && !this.state.filterBy.inActiveFilter;
    const isAccessCodesUsedByAccountReport =
      this.state.selectedReportType?.value ===
      reportNames.accessCodesUsedByAccountValue;
    const filterbyParticipantCheck =
      this.state.selectedReportType.hasDate?.cohortSelection &&
      !this.state.filterByParticipant.activeFilter &&
      !this.state.filterByParticipant.inActiveFilter;
    const filterByModifiedParticipantCheck =
      this.state.selectedReportType.hasDate?.modifiedFilterSelection &&
      !this.state.filterByModifiedParticipant.activeFilter &&
      !this.state.filterByModifiedParticipant.inActiveFilter;
    const emailCheck =
      this.state.emails.length === 0 &&
      this.state.selectedReportType.hasDate?.emailSelection;
    const multiAccountCohortCheck =
      this.state.acc.length === 0 &&
      this.state.selectedReportType.hasDate?.modifiedFilterSelection;

    const message = isWithinAllowedDays(
      this.state.startDate,
      this.state.endDate,
      this.state.selectedReportType?.label === Reports.Count_of_Sims_Used ||
        this.state.selectedReportType?.label ===
          Reports.Sims_Played_Count_and_Average_Feedback
        ? "yearly_reporting"
        : (this.state.selectedReportType?.label === reportNames.onDemandProfessionalStandardSummaryReport
            || this.state.selectedReportType?.label === reportNames.onDemandCaepSimulationSummaryReport
            || this.state.selectedReportType?.label === reportNames.onDemandAaqepSimulationSummaryReport
            || this.state.selectedReportType?.label === reportNames.onDemandNelpPselStandardSummaryReport)
        ? "monthly_reporting"
        : this.state.user.role
    );

    const errorMessage = this.state.errorMsg.monthErrorText;

    const isClientSummaryReport =
      this.state.selectedReportType?.label === reportNames.clientSummaryReport;

    const isMonthlySnapshotProfessionalStandardSummaryReport = 
      this.state.selectedReportType?.label === reportNames.monthlySnapshotProfessionalStandardSummaryReport;

    const isMonthlySnapshotCaepSimulationSummaryReport = 
      this.state.selectedReportType?.label === reportNames.monthlySnapshotCaepSimulationSummaryReport;

    const isQuadrimestralSnapshotAaqepSimulationSummaryReport =
      this.state.selectedReportType?.label === reportNames.quadrimestralSnapshotAaqepSimulationSummaryReport;

    const isQuadrimestralSnapshotNelpPselStandardSummaryReport =
      this.state.selectedReportType?.label === reportNames.quadrimestralSnapshotNelpPselStandardSummaryReport;

    const monthSelected = this.state.monthSelector != null;
    const hasError = this.state.errorMsg.monthErrorText !== "";
    const periodSelected = this.state.selectedPeriod != null;
    const periodHasError = this.state.errorMsg.periodErrorText !== "";
    const isQuadrimesterReport =
      isMonthlySnapshotCaepSimulationSummaryReport ||
      isQuadrimestralSnapshotAaqepSimulationSummaryReport ||
      isQuadrimestralSnapshotNelpPselStandardSummaryReport;
    const periodStillOpen =
      periodSelected &&
      !ENABLE_CURRENT_QUADRIMESTER_SELECTION_FOR_TESTING &&
      quadrimesterIsStillOpen(
        this.state.selectedPeriod.year,
        this.state.selectedPeriod.endMonth
      );
    let periodErrorText = "";
    if (isQuadrimesterReport) {
      if (periodHasError) {
        periodErrorText = this.state.errorMsg.periodErrorText;
      } else if (periodStillOpen) {
        periodErrorText = feildSelectionMessage.futureMonthYear;
      } else if (!periodSelected) {
        periodErrorText = feildSelectionMessage.selectPeriod;
      }
    }

    this.setState({
      errorMsg: {
        report: reportCheck ? feildSelectionMessage.selectReportType : "",
        simulations: simulationsCheck
          ? feildSelectionMessage.selectSimulations
          : "",
        accounts:
          accountCheck || multiAccountCohortCheck
            ? feildSelectionMessage.selectAccounts
            : "",
        cohort: cohortCheck ? feildSelectionMessage.selectCohort : "",
        accountSingleSelect: accountSingleCheck
          ? feildSelectionMessage.accountSingeSelect
          : "",
        filterByParticipant: filterbyParticipantCheck
          ? feildSelectionMessage.filter
          : "",
        filterByModifiedParticipant: filterByModifiedParticipantCheck
          ? feildSelectionMessage.filter
          : "",
        accountFilteration: filterCheck ? feildSelectionMessage.filter : "",
        dateRange: message,
        monthErrorText:
          (isClientSummaryReport || isMonthlySnapshotProfessionalStandardSummaryReport) && monthSelected
            ? errorMessage
            : feildSelectionMessage.selectMonthYear,
        periodErrorText,
      },
      ...(periodStillOpen ? { selectedPeriod: null } : {}),
    });
    if (
      this.state.selectedReportType?.value ===
        reportNames.simDecisionAnalyticsValue &&
      this.state.account !== 0
    ) {
      this.setState({
        errorMsg: {
          simulationsByAccount: simulationsCheckByAccountCheck
            ? feildSelectionMessage.selectSimulations
            : "",
          dateRange: message,
        },
      });

      if (simulationsCheckByAccountCheck) {
        return;
      }
    }
    if (
      this.state.selectedReportType?.value ===
        reportNames.rawDataVersionOfSimSummary &&
      this.state.account !== 0
    ) {
      this.setState({
        errorMsg: {
          simulationsByAccount: simulationsCheckByAccountCheck
            ? feildSelectionMessage.selectSimulations
            : "",
          dateRange: message,
        },
      });
      if (simulationsCheckByAccountCheck) {
        return;
      }
    }
    if (
      (this.state.selectedReportType?.value === reportNames.mceeResult ||
        this.state.selectedReportType?.value ===
          reportNames.recordedResponseTrackReport ||
        this.state.selectedReportType?.value ===
          reportNames.onDemandProfessionalStandardSummaryReport ||
        this.state.selectedReportType?.value ===
          reportNames.onDemandCaepSimulationSummaryReport ||
        this.state.selectedReportType?.value ===
          reportNames.onDemandAaqepSimulationSummaryReport ||
        this.state.selectedReportType?.value ===
          reportNames.onDemandNelpPselStandardSummaryReport) &&
      this.state.account !== 0
    ) {
      this.setState({
        errorMsg: {
          simulationsByAccount: simulationsCheckByAccountCheck
            ? feildSelectionMessage.selectSimulations
            : "",
          dateRange: message,
        },
      });
      if (simulationsCheckByAccountCheck) {
        return;
      }
    }
    if (
      reportCheck ||
      filterCheck ||
      this.state.accountCreatedDateErrorState ||
      cohortCheck ||
      filterbyParticipantCheck ||
      accountSingleCheck ||
      filterByModifiedParticipantCheck ||
      multiAccountCohortCheck ||
      (this.state.selectedReportType?.hasDate.dateRangeFilter == true &&
        message !== "")
    ) {
      return;
    }

    if (this.state.account == 0 && (simulationsCheck || accountCheck)) {
      return;
    }

    const participantActiveStatus = [];
    if (this.state.filterByParticipant?.activeFilter) {
      participantActiveStatus.push(true);
    }
    if (this.state.filterByParticipant?.inActiveFilter) {
      participantActiveStatus.push(false);
    }
    if ((isClientSummaryReport || isMonthlySnapshotProfessionalStandardSummaryReport) && (!monthSelected || hasError)) {
      return;
    }
    if (isQuadrimesterReport && (periodErrorText !== "" || !periodSelected || periodStillOpen)) {
      return;
    }

    const reportCriteria = {
      report: this.state.report,
      startDate: this.state.selectedPeriod
        ? `${this.state.selectedPeriod.year}-${String(this.state.selectedPeriod.startMonth).padStart(2, "0")}-01`
        : formatDateToString(this.state.startDate),
      endDate: this.state.selectedPeriod
        ? dayjs(
            `${this.state.selectedPeriod.year}-${String(this.state.selectedPeriod.endMonth).padStart(2, "0")}-01`
          )
            .endOf("month")
            .format("YYYY-MM-DD")
        : formatDateToString(this.state.endDate),
      accountCreatedDate: formatDateToString(
        this.state.accountCreatedDate === null
          ? new Date()
          : this.state.accountCreatedDate
      ),
      account:
        auth.getUserDetails().accId == null ? 0 : auth.getUserDetails().accId,
      simulations:
        this.state.selectedReportType?.value ===
          (reportNames.rawDataVersionOfSimSummary ||
            reportNames.mceeResult ||
            reportNames.recordedResponseTrackReport ||
            reportNames.onDemandProfessionalStandardSummaryReport ||
            reportNames.onDemandCaepSimulationSummaryReport ||
            reportNames.onDemandAaqepSimulationSummaryReport ||
            reportNames.onDemandNelpPselStandardSummaryReport) && this.state.account !== 0
          ? this.state.simulationsByAccount
          : this.state.simulations,
      accounts:
        this.state.selectedReportType?.value ===
          (reportNames.rawDataVersionOfSimSummary ||
            reportNames.mceeResult ||
            reportNames.recordedResponseTrackReport ||
            reportNames.onDemandProfessionalStandardSummaryReport ||
            reportNames.onDemandCaepSimulationSummaryReport ||
            reportNames.onDemandAaqepSimulationSummaryReport ||
            reportNames.onDemandNelpPselStandardSummaryReport) && this.state.account !== 0
          ? this.state.accList.filter(
              (acc) => acc.value === auth.getUserDetails().accId
            )
          : this.state.acc,
      simulationsByAccount:
        this.state.account == 0 &&
        this.state.selectedReportType?.value ===
          reportNames.simDecisionAnalyticsValue
          ? this.state.simulations
          : this.state.simulationsByAccount,
      accountSimulations:
        this.state.account == 0 &&
        this.state.selectedReportType?.value ===
          reportNames.simDecisionAnalyticsValue
          ? this.state.acc
          : this.state.accountAsList,
      allSimsSelected:
        this.state.simulations.length === this.state.simulationsList.length
          ? true
          : false,
      allAccountSelected: this.state.isAllAccounts,
      reportGenType: this.state.reportGenType,
      userId: this.state.user.userId,
      sortBySim: this.state.sortBy.sortBySim,
      sortByAccount: this.state.sortBy.sortByAccount,
      activeFilter:
        this.state.account == 0 ? this.state.filterBy.activeFilter : true,
      inActiveFilter:
        this.state.account == 0 ? this.state.filterBy.inActiveFilter : true,
      emails: this.state.emails,
      cohortId: this.state.selectedCohort?.value,
      participantActiveStatus: participantActiveStatus,
      modifiedFilter:
        this.state.account == 0
          ? this.state.filterByModifiedParticipant.activeFilter
          : true,
      notModifiedFilter:
        this.state.account == 0
          ? this.state.filterByModifiedParticipant.inActiveFilter
          : true,
      month: this.state.monthSelector ? this.state.monthSelector.$M + 1 : null,
      year: this.state.monthSelector ? this.state.monthSelector.$y : null,
      startMonth: this.state.selectedPeriod?.startMonth ?? null,
      endMonth: this.state.selectedPeriod?.endMonth ?? null,
      periodYear: this.state.selectedPeriod?.year ?? null,
    };

    if (reportCriteria.account === 0) {
      reportCriteria.account = this.state.accId;
    }

    // Dedicated reports are registered in reportPayloads.ts. Pass any new
    // ReportPayloadInput field into buildPayload below.
    const selectedReportTypeValue = this.state.selectedReportType?.value;
    const dedicated =
      typeof selectedReportTypeValue === "string"
        ? DEDICATED_REPORT_ENDPOINTS[selectedReportTypeValue]
        : undefined;
    const generateUrl = dedicated ? dedicated.url : LEGACY_GENERATE_URL;
    const generatePayload = dedicated
      ? dedicated.buildPayload({
          startDate: reportCriteria.startDate,
          endDate: reportCriteria.endDate,
          selectedAccounts: this.state.acc,
          isAllAccounts: this.state.isAllAccounts,
          activeFilter: this.state.filterBy.activeFilter,
          inactiveFilter: this.state.filterBy.inActiveFilter,
          reportGenType: this.state.reportGenType,
        })
      : reportCriteria;

    this.setState((prev) => ({
      loading: true,
      ...(isAccessCodesUsedByAccountReport
        ? {
            errorMsg: {
              ...prev.errorMsg,
              excelReportCheck: "",
            },
          }
        : {}),
    }));
    await AppService.downloadFromStream(
      generatePayload,
      generateUrl,
      "POST",
      this.state?.selectedReportType?.hasDate?.type
        ? this.state?.selectedReportType?.hasDate?.type
        : "blob",
      true
    )
      .then((response) => {
        if (this.state?.selectedReportType?.hasDate?.type) {
          this.setState({ isShowingModal: true });
          return;
        }
        if (this.state.reportGenType == "pdf") {
          var blob = new Blob([response.data], { type: "application/pdf" }),
            url = URL.createObjectURL(blob),
            _iFrame = document.createElement("iframe");

          _iFrame.setAttribute("src", url);
          _iFrame.setAttribute(
            "style",
            "visibility:visible;width:100%;height:700px"
          );
          $("#reportDiv").append(_iFrame);
        } else {
          var blob = new Blob([response.data], {
            type: "application/vnd.ms-excel",
          });
          var url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.href = url;
          a.target = "_balank";
          a.download = this.state.report;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        }
      })
      .catch(async (error: unknown) => {
        if (!isAccessCodesUsedByAccountReport) {
          console.log(error);
          return;
        }
        const fallback =
          reportMessages.accessCodesUsedByAccountGenerateFailed;
        let message = fallback;
        if (axios.isAxiosError(error)) {
          message = await extractApiMessage(error, fallback);
        }
        this.setState((prev) => ({
          errorMsg: {
            ...prev.errorMsg,
            excelReportCheck: message,
          },
        }));
      });

    this.setState({ loading: false });
  };

  loadData = async () => {
    this.setState({ loading: true });
    const accounts = await AppService.getAll("accounts/list");
    const teacherSimsEligible =
      this.state.userRole === ROLE_SUPER_ADMIN
        ? await AppService.getAll("accounts/teacherSimsEligible")
        : { data: [] };
    const cohortAccountList = await AppService.getAll(
      "accounts/cohortAccountList"
    );
    const cohortList = await AppService.getAll(
      "cohorts/retrieveCohortsPerAccount"
    );
    const simulations = await AppService.getAll("sims/list/external");
    const simulationsByAccount = await AppService.getAll(
      `sims/get-simulations-by-account/${this.state.account}`
    );
    const regions = await AppService.getAll("region/getAllRegions");
    let emails = { data: [] };
    try {
      emails = await AppService.getAll(
        `sims/get-emails-by-account/${this.state.account}`
      );
    } catch (error) {
      console.error(error.userMessage);
    }
    const simulationList = simulations.data.map((simDoc) => {
      return { value: simDoc.simCode, label: simDoc.label };
    });
    const accountList = accounts.data.map((account) => {
      return {
        ...account,
        value: account.value,
        label: account.label,
        regionName: account.regionName,
        active: account.active,
      };
    });
    const teacherPayload = teacherSimsEligible?.data;
    const teacherRows = Array.isArray(teacherPayload)
      ? teacherPayload
      : Array.isArray(teacherPayload?.data)
        ? teacherPayload.data
        : [];
    const teacherSimsEligibleList = teacherRows.map((account: any) => {
      const value = account.value ?? account.accId;
      const label =
        account.label ??
        account.accName ??
        account.accountName ??
        (value != null ? String(value) : "");
      let active = account.active;
      if (active !== "Active" && active !== "InActive") {
        if (typeof active === "boolean") {
          active = active ? "Active" : "InActive";
        } else {
          active = "Active";
        }
      }
      return {
        ...account,
        value,
        label,
        regionName: account.regionName ?? account.region ?? "",
        active,
      };
    });
    const simulationsListByAccount = simulationsByAccount.data.map((sim) => {
      return { value: sim.simCode, label: sim.label };
    });
    accounts.data.unshift({ value: 0, label: "All" });
    const regionList = regions.data.map((reg) => {
      return { value: reg.value, label: reg.label };
    });
    regions.data.unshift({ value: 0, label: "All" });
    const emailList = (emails.data || []).map((email, index) => {
      return { value: index + 1, label: email };
    });

    // Filtering objects where the 'active' property is 'Active'
    const activeAccounts = accounts.data.filter(
      (obj) => obj.active === "Active"
    );

    activeAccounts.unshift({ value: 0, label: "All" });

    const activeAccMultiSelect = accountList.filter(
      (obj) => obj.active === "Active"
    );
    const inActiveAccMultiSelect = accountList.filter(
      (obj) => obj.active === "InActive"
    );

    this.setState({
      accList: activeAccounts,
      accountList: accountList,
      originalAccountList: accountList,
      accounts: accounts.data[0],
      accId: 0,
      loading: false,
      simulationsList: simulationList,
      simulationsListByAccount: simulationsListByAccount,
      simsAsList: simulationsListByAccount,
      regionList: regionList,
      activeAccounts: activeAccounts,
      activeAccMultiSelect: activeAccMultiSelect,
      inActiveAccMultiSelect: inActiveAccMultiSelect,
      emailList: emailList,
      cohortList: cohortList?.data?.data,
      cohortAccountList: cohortAccountList?.data?.data,
      teacherSimsEligibleList: teacherSimsEligibleList,
      singleSelectAccountList: activeAccounts,
    });

    const accDetail = findAccountByValue(
      accountList,
      this.state.account
    );
    this.setState({ accountAsList: [...this.state.accountAsList, accDetail] });
  };

  handleSimulationChange = (newValue, actionMeta) => {
    let list;
    const { action, option, removedValue } = actionMeta;
    if (action === "select-option") {
      if (option.value === selectAllSimulations.value) {
        list = this.state.simulationsList.filter(
          ({ value }) => value !== option.value
        );
        this.setState({ simulations: list, simulationsList: list });
      } else {
        list = this.state.simulations;
        list.push(option);
        this.setState({ simulations: list });
      }
    } else if (action === "remove-value") {
      list = this.state.simulations.filter(
        ({ value }) => value !== removedValue.value
      );
      this.setState({ simulations: list });
    } else if (action === "clear") {
      this.setState({ simulations: [] });
    }
    this.setState({
      errorMsg: {
        report: this.state.errorMsg.report,
        simulations: "",
        accounts: this.state.errorMsg.accounts,
        dateRange: this.state.errorMsg.dateRange,
      },
    });
    this.getSimulationOptions();
  };

  getSimulationOptions = () => {
    if (this.state.simulations.length == this.state.simulationsList.length) {
      return [...this.state.simulationsList];
    } else {
      return [selectAllSimulations, ...this.state.simulationsList];
    }
  };

  handleRegionChange = (newValue, actionMeta) => {
    let list;
    const { action, option, removedValue } = actionMeta;
    if (action === "select-option") {
      if (option.value === selectAllRegions.value) {
        list = this.state.regionList.filter(
          ({ value }) => value !== option.value
        );
        this.setState({ region: list, regionList: list });
      } else {
        list = this.state.region;
        list.push(option);
        this.setState({ region: list });
      }
    } else if (action === "remove-value") {
      list = this.state.region.filter(
        ({ value }) => value !== removedValue.value
      );
      this.setState({ region: list });
    } else if (action === "clear") {
      const regionsList = this.state.region;
      this.setState({ region: [] });
      if (!this.state.manuallySelectedAccounts) {
        this.setState({
          acc: [],
          manuallyRemovedAccounts: [],
          isAllAccounts: false,
        });
      } else {
        const persistedAccounts = [...this.state.acc];

        // Extract labels from the regions data
        const regionLabels = regionsList.map((region) => region.label);

        // Filter out accounts with matching regionName and label
        const unmatchedAccounts = persistedAccounts.filter((account) => {
          // Checking if regionName does not exist in the regionLabels array for every account
          return !regionLabels.some((label) => label === account.regionName);
        });
        this.setState({ acc: unmatchedAccounts, isAllAccounts: false });
      }
    }

    if (action !== "clear") {
      const accountsFilterBy = this.filterAccountsByFilter();
      const filteredAccounts = this.findMatchingObjects(
        list,
        accountsFilterBy,
        removedValue
      );

      // Extracting labels from manually removed accounts
      const selectedRegionAcc = this.state.manuallyRemovedAccounts.map(
        (item) => item.label
      );

      // Filter out matching items from filtered accounts
      let removedAccWithRegions = filteredAccounts.filter(
        (item: any) => !selectedRegionAcc.includes(item.label)
      );

      // Checking if all accounts for a region are manually removed
      const manuallyRemovedRegionLabels =
        this.state.manuallyRemovedAccounts.map((item) => item.regionName);
      const regionsWithNoManuallyRemovedAccounts = this.state.region.filter(
        (item) => !manuallyRemovedRegionLabels.includes(item.label)
      );

      // If all accounts for a region are manually removed, remove that region
      regionsWithNoManuallyRemovedAccounts.forEach((region) => {
        const regionAccounts = filteredAccounts.filter(
          (account: any) => account.regionName === region.label
        );
        if (regionAccounts.length === 0) {
          removedAccWithRegions = removedAccWithRegions.filter(
            (account: any) => account.regionName !== region.label
          );
        }
      });

      if (!this.state.manuallySelectedAccounts) {
        this.setState({ acc: removedAccWithRegions });
      } else {
        this.setState({ acc: filteredAccounts });
      }
    }

    this.getRegionOptions();
  };

  findMatchingObjects = (
    listOfRegions: any,
    listOfAccountsWithRegion: any,
    removedOption: any
  ) => {
    let result: any = new Set([...this.state.acc]);

    if (removedOption) {
      const preservedAccounts = this.state.acc.filter(
        (item2: any) => item2.regionName !== removedOption.label
      );
      result = new Set([...preservedAccounts]);
    }

    listOfRegions.forEach((item1: any) => {
      const matchedObjects = listOfAccountsWithRegion.filter(
        (item2: any) => item2.regionName === item1.label
      );
      if (matchedObjects.length > 0) {
        result = new Set([...result, ...matchedObjects]);
      }
    });

    return Array.from(result);
  };

  getRegionOptions = () => {
    if (this.state.region.length == this.state.regionList.length) {
      return [...this.state.regionList];
    } else {
      return [selectAllRegions, ...this.state.regionList];
    }
  };

  handleSimulationChangeByAccount = (newValue, actionMeta) => {
    let list;
    const { action, option, removedValue } = actionMeta;
    if (action === "select-option") {
      if (option.value === selectAllSimulationByAccount.value) {
        list = this.state.simulationsListByAccount.filter(
          ({ value }) => value !== option.value
        );
        this.setState({
          simulationsByAccount: list,
          simulationsListByAccount: list,
        });
      } else {
        list = this.state.simulationsByAccount;
        list.push(option);
        this.setState({ simulationsByAccount: list });
      }
    } else if (action === "remove-value") {
      list = this.state.simulationsByAccount.filter(
        ({ value }) => value !== removedValue.value
      );
      this.setState({ simulationsByAccount: list });
    } else if (action === "clear") {
      this.setState({ simulationsByAccount: [] });
    }
    this.setState({
      errorMsg: {
        report: this.state.errorMsg.report,
        simulationsByAccount: "",
        dateRange: this.state.errorMsg.dateRange,
      },
    });
    this.getSimulationOptionsByAccount();
  };

  getSimulationOptionsByAccount = () => {
    if (
      this.state.simulationsByAccount.length ==
      this.state.simulationsListByAccount.length
    ) {
      return [...this.state.simulationsListByAccount];
    } else {
      return [
        selectAllSimulationByAccount,
        ...this.state.simulationsListByAccount,
      ];
    }
  };

  handleEmailChange = (newValue, actionMeta) => {
    let list = handleMultiSelectChange(
      newValue,
      actionMeta,
      this.state.emailList,
      this.state.emails,
      selectAllEmails
    );
    this.setState({ emails: list });
    this.setState({
      errorMsg: {
        report: this.state.errorMsg.report,
        simulations: this.state.errorMsg.simulations,
        emails: "",
      },
    });
  };

  handleMultiSelectAccountChange = (newValue, actionMeta) => {
    this.setState({ account: 0, accId: 0, accounts: [] });
    let list = handleMultiSelectChange(
      newValue,
      actionMeta,
      this.state.cohortAccountList,
      this.state.acc,
      selectAllAccounts
    );
    this.setState({ acc: list });
    this.setState({
      errorMsg: {
        report: this.state.errorMsg.report,
        simulations: this.state.errorMsg.simulations,
        accounts: "",
        dateRange: this.state.errorMsg.dateRange,
        filterByModifiedParticipant:
          this.state.errorMsg.filterByModifiedParticipant,
      },
    });
  };

  handleAccountChange = (selectedOptions, actionMeta) => {
    this.setState({ account: 0, accId: 0, accounts: [] });
    let list;
    let removedAccount, result;
    const { action, option, removedValue } = actionMeta;
    if (action === "select-option") {
      if (option.value === selectAllAccounts.value) {
        const filteredAccounts = this.filterAccountsByFilter();
        result = this.checkAllAccounts(filteredAccounts);
        this.setState({
          acc: filteredAccounts,
          manuallySelectedAccounts: true,
          manuallyRemovedAccounts: [],
          isAllAccounts: result,
        });
      } else {
        list = this.state.acc;
        list.push(option);
        this.setState({
          acc: list,
          manuallySelectedAccounts: true,
          manuallyRemovedAccounts: [],
          isAllAccounts: false,
        });
      }
    } else if (action === "remove-value") {
      list = this.state.acc.filter(({ value }) => value !== removedValue.value);
      result = this.checkAllAccounts(list);
      removedAccount = this.state.acc.filter(
        ({ value }) => value === removedValue.value
      );
      this.setState((prevState) => ({
        acc: list,
        manuallyRemovedAccounts: [
          ...prevState.manuallyRemovedAccounts,
          ...removedAccount,
        ],
        manuallySelectedAccounts: false,
        isAllAccounts: result,
      }));
    } else if (action === "clear") {
      this.setState({
        acc: [],
        manuallySelectedAccounts: false,
        manuallyRemovedAccounts: [],
        isAllAccounts: false,
      });
    }

    this.setState({
      errorMsg: {
        report: this.state.errorMsg.report,
        simulations: this.state.errorMsg.simulations,
        accounts: "",
        isAllAccounts: result,
        monthErrorText: this.state.errorMsg.monthErrorText,
        periodErrorText: this.state.errorMsg.periodErrorText,
      },
    });
  };

  checkAllAccounts = (filteredAccounts) => {
    let result;
    if (
      this.state.filterBy.activeFilter &&
      this.state.filterBy.inActiveFilter
    ) {
      result =
        filteredAccounts.length === this.state.accountList.length
          ? true
          : false;
    } else if (this.state.filterBy.activeFilter) {
      result =
        filteredAccounts.length === this.state.activeAccMultiSelect.length
          ? true
          : false;
    } else if (this.state.filterBy.inActiveFilter) {
      result =
        filteredAccounts.length === this.state.inActiveAccMultiSelect.length
          ? true
          : false;
    }
    return result;
  };

  filterAccountsByFilter = () => {
    let accFilter;
    if (
      this.state.filterBy.activeFilter &&
      this.state.filterBy.inActiveFilter
    ) {
      return [...this.state.accountList];
    } else if (this.state.filterBy.activeFilter) {
      accFilter = this.state.accountList.filter(
        (obj) => obj.active === "Active"
      );
      return accFilter;
    } else if (this.state.filterBy.inActiveFilter) {
      accFilter = this.state.accountList.filter(
        (obj) => obj.active === "InActive"
      );
      return accFilter;
    }
  };

  getAccountOptions = () => {
    const allAccountsSelected = this.state.isAllAccounts;

    let result;

    if (
      this.state.filterBy.activeFilter &&
      this.state.filterBy.inActiveFilter
    ) {
      result = !allAccountsSelected
        ? [selectAllAccounts, ...this.state.accountList]
        : [...this.state.accountList];
    } else if (this.state.filterBy.activeFilter) {
      const activeAccounts = this.state.accountList.filter(
        (obj) => obj.active === "Active"
      );
      result = !allAccountsSelected
        ? [selectAllAccounts, ...activeAccounts]
        : [...activeAccounts];
    } else if (this.state.filterBy.inActiveFilter) {
      const inActiveAccounts = this.state.accountList.filter(
        (obj) => obj.active === "InActive"
      );
      result = !allAccountsSelected
        ? [selectAllAccounts, ...inActiveAccounts]
        : [...inActiveAccounts];
    }
    return result;
  };

  handleChange = (filedName, errorName, selectedOption) => {
    this.setState((prevState) => ({
      [filedName]: selectedOption,
      errorMsg: {
        ...prevState.errorMsg,
        [errorName]: "",
      },
    }));
    if (filedName === "accounts") {
      this.setState({
        accId: selectedOption.value,
      });
    }
  };

  handleReportGenType = (event) => {
    this.setState({ reportGenType: event.target.value });
  };

  handleDateChange = (date) => {
    const todayDate = new Date();
    let errorState = false;
    if (date) {
      if (isNaN(Date.parse(date)) || todayDate <= date) {
        errorState = true;
      }
    }
    this.setState({
      accountCreatedDate: date,
      accountCreatedDateErrorState: errorState,
    });
  };

  enableDatePicker = () => {
    if (
      this.state.selectedReportType.hasDate?.dateRangeFilter ||
      this.state.report === ""
    ) {
      return true;
    } else {
      return false;
    }
  };

  handleMonthChange = (date) => {
    const today = dayjs(); // current date
    const minDate = dayjs("1970-01-01"); // minimum allowed date

    let errorText = "";
    if (!date) {
      errorText = feildSelectionMessage.selectMonthYear;
    } else if (!dayjs(date).isValid()) {
      errorText = feildSelectionMessage.invalidMonthYear;
    } else if (dayjs(date).isAfter(today, "month")) {
      errorText = feildSelectionMessage.futureMonthYear;
    } else if (dayjs(date).isBefore(minDate, "month")) {
      errorText = "Month/Year cannot be before Jan 1970";
    }

    this.setState((prevState) => ({
      monthSelector: date,
      errorMsg: {
        ...prevState.errorMsg,
        monthErrorText: errorText || "",
      },
    }));
  };

  getQuadrimesterFieldLabel = () => {
    if (this.state.selectedPeriod?.label) {
      return this.state.selectedPeriod.label;
    }
    const raw = this.state.selectedPeriodPickerValue;
    if (!raw || !dayjs(raw).isValid()) {
      return "";
    }
    const selectedDate = dayjs(raw);
    const monthIndex = selectedDate.month();
    const rangeLabel =
      monthIndex <= 3 ? "Jan - Apr" : monthIndex <= 7 ? "May - Aug" : "Sep - Dec";
    return `${rangeLabel} ${selectedDate.year()}`;
  };

  handlePeriodChange = (date) => {
    const today = dayjs();
    const minDate = dayjs("1970-01-01");

    if (!date) {
      this.setState((prevState) => ({
        selectedPeriod: null,
        selectedPeriodPickerValue: null,
        errorMsg: {
          ...prevState.errorMsg,
          periodErrorText: feildSelectionMessage.selectPeriod,
        },
      }));
      return;
    }

    const selectedDate = dayjs(date);
    if (!selectedDate.isValid()) {
      this.setState((prevState) => ({
        selectedPeriod: null,
        selectedPeriodPickerValue: date,
        errorMsg: {
          ...prevState.errorMsg,
          periodErrorText: feildSelectionMessage.invalidMonthYear,
        },
      }));
      return;
    }

    if (selectedDate.isBefore(minDate, "month")) {
      this.setState((prevState) => ({
        selectedPeriod: null,
        selectedPeriodPickerValue: selectedDate,
        errorMsg: {
          ...prevState.errorMsg,
          periodErrorText: "Month/year cannot be before Jan 1970",
        },
      }));
      return;
    }

    if (selectedDate.isAfter(today, "month")) {
      this.setState((prevState) => ({
        selectedPeriod: null,
        selectedPeriodPickerValue: selectedDate,
        errorMsg: {
          ...prevState.errorMsg,
          periodErrorText: feildSelectionMessage.futureMonthYear,
        },
      }));
      return;
    }

    const month = selectedDate.month() + 1;
    const year = selectedDate.year();
    const period = quadrimesterForMonth(month);

    if (
      period &&
      !ENABLE_CURRENT_QUADRIMESTER_SELECTION_FOR_TESTING &&
      quadrimesterIsStillOpen(year, period.endMonth)
    ) {
      this.setState((prevState) => ({
        selectedPeriod: null,
        selectedPeriodPickerValue: selectedDate,
        errorMsg: {
          ...prevState.errorMsg,
          periodErrorText: feildSelectionMessage.futureMonthYear,
        },
      }));
      return;
    }

    if (!period) {
      this.setState((prevState) => ({
        selectedPeriod: null,
        selectedPeriodPickerValue: selectedDate,
        errorMsg: {
          ...prevState.errorMsg,
          periodErrorText: feildSelectionMessage.selectPeriod,
        },
      }));
      return;
    }

    this.setState((prevState) => ({
      selectedPeriodPickerValue: selectedDate,
      selectedPeriod: {
        value: `${year}-${period.startMonth}-${period.endMonth}`,
        label: `${period.label} ${year}`,
        startMonth: period.startMonth,
        endMonth: period.endMonth,
        year: year,
      },
      errorMsg: { ...prevState.errorMsg, periodErrorText: "" },
    }));
  };

  handleSort = (e, checkBoxName) => {
    this.setState({
      sortBy: { ...this.state.sortBy, [checkBoxName]: e.target.checked },
    });
  };

  handleAccountFilter = (e, checkBoxName) => {
    const isChecked = e.target.checked || false;

    this.setState(
      (prevState) => ({
        filterBy: { ...prevState.filterBy, [checkBoxName]: isChecked },
        errorMsg: {
          accountFilteration: "",
          dateRange: this.state.errorMsg.dateRange,
          monthErrorText: this.state.errorMsg.monthErrorText,
          periodErrorText: this.state.errorMsg.periodErrorText,
        },
      }),
      () => {
        if (
          this.state.filterBy.activeFilter &&
          this.state.filterBy.inActiveFilter
        ) {
          const allAccounts = [...this.state.accountList];
          allAccounts.unshift({ value: 0, label: "All" });
          this.setState({ singleSelectAccountList: allAccounts });
        } else if (this.state.filterBy.activeFilter) {
          this.setState({ singleSelectAccountList: this.state.activeAccounts });
        } else if (this.state.filterBy.inActiveFilter) {
          const inActiveAccounts = this.state.accountList.filter(
            (obj) => obj.active === "InActive"
          );
          inActiveAccounts.unshift({ value: 0, label: "All" });
          this.setState({
            inActiveAccounts: inActiveAccounts,
            singleSelectAccountList: inActiveAccounts,
          });
        } else {
          console.debug("inside else");
        }
      }
    );
  };

  handleCheckBoxChange = (event, checkBoxName, filterKey, errorKey) => {
    const isChecked = event.target.checked;

    this.setState((prevState) => ({
      [filterKey]: {
        ...prevState[filterKey],
        [checkBoxName]: isChecked,
      },
      errorMsg: {
        ...prevState.errorMsg,
        [errorKey]: "",
        dateRange: prevState.errorMsg.dateRange,
      },
    }));
  };

  render() {
    const selectionRange = {
      startDate: this.state.startDate,
      endDate: this.state.endDate,
    };

    return (
      <div>
        <div className="page">
          <DefaultHeader history={this.props.history} />
          <div className="page-content d-flex align-items-stretch fields-font">
            <DefaultSideBar activeRMLink={true} />
            <div className="content-inner">
              {/* <!-- Page Header--> */}
              <header className="page-header">
                <div className="container-fluid">
                  <h2 className="heading">Reports Management</h2>
                </div>
              </header>

              <section className="tables">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="card">
                        <div className="card-header d-flex align-items-center">
                          <h3 className="sub-heading">Reports</h3>
                        </div>
                        <section className="simulations-section p-1">
                          <div
                            className="row"
                            style={{ marginTop: 12, width: "100%" }}
                          >
                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="mb-4 col-12">
                                  <div className="row">
                                    <label className="col-3 form-control-label mt-2 required label">
                                      Select Report
                                    </label>
                                    <div className="col-9">
                                      <Select
                                        name="reportTypes"
                                        className="basic-multi-select fields-font"
                                        isMulti={false}
                                        options={this.state.reportTypes}
                                        value={this.state.selectedReportType}
                                        onChange={this.handleReportChanged}
                                      />
                                    </div>
                                    {this.state.errorMsg.report &&
                                      showErrorMessage(
                                        this.state.errorMsg.report
                                      )}
                                  </div>
                                </div>
                              </div>

                              {(auth.getUserDetails().accId === null ||
                                auth.getUserDetails().accId == 0) && (
                                <>
                                  {!this.state.selectedReportType.hasDate
                                    ?.simSelection &&
                                    !this.state.selectedReportType.hasDate
                                      ?.multipleAccountSelection &&
                                    !this.state.selectedReportType.hasDate
                                      ?.modifiedFilterSelection && (
                                      <div className="form-group row mb-4">
                                        <label
                                          className={`col-sm-3 form-control-label mt-2 label ${
                                            this.state.report ===
                                              "Cohort Progress Report" &&
                                            "required"
                                          }`}
                                        >
                                          Select Account:{" "}
                                        </label>
                                        <div className="col-sm-9">
                                          <Select
                                            name="accounts"
                                            isMulti={false}
                                            options={
                                              this.state.singleSelectAccountList
                                            }
                                            value={this.state.accounts}
                                            className="basic-multi-select fields-font"
                                            onChange={(e) =>
                                              this.handleChange(
                                                "accounts",
                                                "accountSingleSelect",
                                                e
                                              )
                                            }
                                          />
                                        </div>
                                        {this.state.report ===
                                          "Cohort Progress Report" &&
                                          this.state.errorMsg
                                            .accountSingleSelect &&
                                          showErrorMessage(
                                            this.state.errorMsg
                                              .accountSingleSelect
                                          )}
                                      </div>
                                    )}

                                  {this.state.selectedReportType?.value ===
                                    reportNames.simDecisionAnalyticsValue && (
                                    <GenericMultiSelectField
                                      label={"Select Regions"}
                                      name="regionsList"
                                      options={this.getRegionOptions()}
                                      value={this.state.region}
                                      onChange={this.handleRegionChange}
                                      errorMessage={""}
                                    />
                                  )}
                                  {this.state.selectedReportType.hasDate
                                    ?.multipleAccountSelection && (
                                    <GenericMultiSelectField
                                      label="Select Accounts"
                                      name="accountsList"
                                      options={this.getAccountOptions()}
                                      value={this.state.acc}
                                      onChange={this.handleAccountChange}
                                      errorMessage={
                                        this.state.errorMsg.accounts
                                      }
                                      required
                                    />
                                  )}
                                  {this.state.selectedReportType.hasDate
                                    ?.simSelection && (
                                    <GenericMultiSelectField
                                      label="Select Simulations"
                                      name="simulationsList"
                                      options={this.getSimulationOptions()}
                                      value={this.state.simulations}
                                      onChange={this.handleSimulationChange}
                                      errorMessage={
                                        this.state.errorMsg.simulations
                                      }
                                      required
                                    />
                                  )}

                                  {this.state.selectedReportType.hasDate
                                    ?.modifiedFilterSelection && (
                                    <GenericMultiSelectField
                                      label="Select Accounts"
                                      name="accountsList"
                                      options={getMultiSelectOptions(
                                        this.state.cohortAccountList,
                                        this.state.acc,
                                        selectAllAccounts
                                      )}
                                      value={this.state.acc}
                                      onChange={
                                        this.handleMultiSelectAccountChange
                                      }
                                      errorMessage={
                                        this.state.errorMsg.accounts
                                      }
                                      required
                                    />
                                  )}
                                  {this.state.selectedReportType.hasDate
                                    ?.createdDateFilter && (
                                    <div className="form-group row">
                                      <label className="col-3 form-control-label mt-2 label">
                                        Account Created Date
                                      </label>
                                      <div className="col-sm-9">
                                        <div className="form-control mb-3 fields-font form-active">
                                          <MuiPickersUtilsProvider
                                            utils={DateFnsUtils}
                                          >
                                            <KeyboardDatePicker
                                              style={{ width: "100%" }}
                                              variant="inline"
                                              placeholder="MM-DD-YYYY"
                                              maxDate={new Date()}
                                              invalidDateMessage={
                                                <p className="error">
                                                  Please enter a date in
                                                  MM-DD-YYYY format.
                                                </p>
                                              }
                                              maxDateMessage={
                                                <p className="error">
                                                  Future date is not allowed
                                                </p>
                                              }
                                              minDateMessage={null}
                                              value={
                                                this.state.accountCreatedDate
                                              }
                                              onChange={this.handleDateChange}
                                              format="MM-dd-yyyy"
                                              autoOk={true}
                                              disablePast={false}
                                              InputProps={{
                                                disableUnderline: true,
                                                readOnly: false,
                                              }}
                                            />
                                          </MuiPickersUtilsProvider>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              )}
                              {this.state.selectedReportType.hasDate
                                ?.cohortSelection && (
                                <div className="form-group row mb-4">
                                  <label className="col-sm-3 form-control-label mt-2 label required">
                                    Select Cohort:{" "}
                                  </label>
                                  <div className="col-sm-9">
                                    <Select
                                      name="cohort"
                                      isMulti={false}
                                      options={
                                        this.state.cohortList[this.state.accId]
                                      }
                                      value={this.state.selectedCohort}
                                      className="basic-multi-select fields-font"
                                      onChange={(e) =>
                                        this.handleChange(
                                          "selectedCohort",
                                          "cohort",
                                          e
                                        )
                                      }
                                    />
                                  </div>
                                  {this.state.errorMsg.cohort &&
                                    showErrorMessage(
                                      this.state.errorMsg.cohort
                                    )}
                                </div>
                              )}
                              {(this.state.selectedReportType?.value ===
                                reportNames.simDecisionAnalyticsValue ||
                                this.state.selectedReportType?.value ===
                                  reportNames.rawDataVersionOfSimSummary ||
                                this.state.selectedReportType?.value ===
                                  reportNames.mceeResult ||
                                this.state.selectedReportType?.value ===
                                  reportNames.recordedResponseTrackReport ||
                                this.state.selectedReportType?.label ===
                                 reportNames.onDemandProfessionalStandardSummaryReport ||
                                this.state.selectedReportType?.label ===
                                 reportNames.onDemandCaepSimulationSummaryReport ||
                                this.state.selectedReportType?.label ===
                                 reportNames.onDemandAaqepSimulationSummaryReport ||
                                this.state.selectedReportType?.label ===
                                 reportNames.onDemandNelpPselStandardSummaryReport) &&
                                this.state.account !== 0 && (
                                  <GenericMultiSelectField
                                    label="Select Simulations"
                                    name="simulationsListBYAccount"
                                    onChange={
                                      this.handleSimulationChangeByAccount
                                    }
                                    options={this.getSimulationOptionsByAccount()}
                                    value={this.state.simulationsByAccount}
                                    errorMessage={
                                      this.state.errorMsg.simulationsByAccount
                                    }
                                    required
                                  />
                                )}

                              {this.state.selectedReportType?.value ===
                                reportNames.rawDataVersionOfSimSummary && (
                                <GenericMultiSelectField
                                  label={"Select Emails"}
                                  name="emailsList"
                                  options={getMultiSelectOptions(
                                    this.state.emailList,
                                    this.state.emails,
                                    selectAllEmails
                                  )}
                                  value={this.state.emails}
                                  onChange={this.handleEmailChange}
                                  errorMessage={""}
                                />
                              )}

                              {(this.state.selectedReportType.hasDate
                                ?.accountActiveFilter ||
                                this.state.report === "") &&
                                this.state.account == 0 && (
                                  <>
                                    <div
                                      className="row"
                                      style={{ marginTop: 18 }}
                                    >
                                      <label className="col-3 form-control-label mt-2 content-body required label">
                                        Filter By
                                      </label>
                                      <div className="col-9">
                                        <FormGroup row>
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                color="primary"
                                                checked={
                                                  this.state.filterBy
                                                    .activeFilter
                                                }
                                                onChange={(e) =>
                                                  this.handleAccountFilter(
                                                    e,
                                                    "activeFilter"
                                                  )
                                                }
                                              />
                                            }
                                            label="Active"
                                          />
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                color="primary"
                                                checked={
                                                  this.state.filterBy
                                                    .inActiveFilter
                                                }
                                                onChange={(e) =>
                                                  this.handleAccountFilter(
                                                    e,
                                                    "inActiveFilter"
                                                  )
                                                }
                                              />
                                            }
                                            label="InActive"
                                          />
                                        </FormGroup>
                                      </div>
                                    </div>
                                    {this.state.errorMsg.accountFilteration &&
                                      showErrorMessage(
                                        this.state.errorMsg.accountFilteration
                                      )}
                                  </>
                                )}
                              {this.state.selectedReportType.hasDate
                                ?.modifiedFilterSelection &&
                                this.state.account == 0 && (
                                  <ParticipantsFilter
                                    filterBy={
                                      this.state.filterByModifiedParticipant
                                    }
                                    onFilterChange={this.handleCheckBoxChange}
                                    errorMsg={
                                      this.state.errorMsg
                                        .filterByModifiedParticipant
                                    }
                                    labels={{
                                      text: "Filter By Participants Modified",
                                      activeLabel: "Modified",
                                      inActiveLabel: "Not Modified ",
                                    }}
                                    filterKey={"filterByModifiedParticipant"}
                                    errorKey={"filterByModifiedParticipant"}
                                  />
                                )}

                              {this.state.selectedReportType.hasDate
                                ?.participantFilter && (
                                <ParticipantsFilter
                                  filterBy={this.state.filterByParticipant}
                                  onFilterChange={this.handleCheckBoxChange}
                                  errorMsg={
                                    this.state.errorMsg.filterByParticipant
                                  }
                                  labels={{
                                    text: "Filter By Participants",
                                    activeLabel: "Active",
                                    inActiveLabel: "InActive ",
                                  }}
                                  filterKey={"filterByParticipant"}
                                  errorKey={"filterByParticipant"}
                                />
                              )}

                              {this.enableDatePicker() && (
                                <>
                                  <div
                                    className="row"
                                    style={{ marginTop: 18 }}
                                  >
                                    <label className="col-3 form-control-label mt-2 content-body required label">
                                      Date Range
                                    </label>

                                    <div className="col-9">
                                      <DateRangePicker
                                        ranges={[selectionRange]}
                                        onChange={this.handleDateRangeChanged}
                                        maxDate={new Date()}
                                        inputRanges={InputRanges}
                                      />
                                    </div>
                                    {this.state.errorMsg.dateRange === "" && (
                                      <div className="col-9 offset-3 mt-1">
                                        <p className="m-0 p-0">
                                          <span className="required"></span>{" "}
                                          Choose a date range within{" "}
                                          {
                                            ROLE_REPORT_GEN_LIMIT[
                                              this.state.selectedReportType
                                                ?.label ===
                                                Reports.Count_of_Sims_Used ||
                                              this.state.selectedReportType
                                                ?.label ===
                                                Reports.Sims_Played_Count_and_Average_Feedback
                                                ? "yearly_reporting"
                                                :  (this.state.selectedReportType
                                                    ?.label === reportNames.onDemandProfessionalStandardSummaryReport
                                                    || this.state.selectedReportType
                                                    ?.label === reportNames.onDemandCaepSimulationSummaryReport
                                                    || this.state.selectedReportType
                                                    ?.label === reportNames.onDemandAaqepSimulationSummaryReport
                                                    || this.state.selectedReportType
                                                    ?.label === reportNames.onDemandNelpPselStandardSummaryReport)
                                                 ? "monthly_reporting": this.state.user.role
                                            ]
                                          }{" "}
                                          days to generate the report.
                                        </p>
                                      </div>
                                    )}
                                  </div>
                                  {this.state.errorMsg.dateRange !== "" &&
                                    showErrorMessage(
                                      this.state.errorMsg.dateRange
                                    )}
                                </>
                              )}

                              {this.state.selectedReportType.hasDate
                                ?.monthSelection && (
                                <div className="row" style={{ marginTop: 18 }}>
                                  <label className="col-3 form-control-label mt-2 content-body required label">
                                    Date Range
                                  </label>

                                  <div className="col-9">
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <DatePicker
                                        views={["month", "year"]}
                                        disableFuture
                                        openTo="month"
                                        value={this.state.monthSelector}
                                        onChange={(newValue) =>
                                          this.handleMonthChange(newValue)
                                        }
                                        className="w-100"
                                        minDate={dayjs(
                                          "01-01-1970",
                                          "MM-DD-YYYY"
                                        )}
                                        slotProps={{
                                          textField: {
                                            size: "small",
                                            sx: snapshotDateFieldSx,
                                          },
                                        }}
                                      />
                                    </LocalizationProvider>
                                  </div>
                                  {this.state.errorMsg.monthErrorText !== "" &&
                                    showErrorMessage(
                                      this.state.errorMsg.monthErrorText
                                    )}
                                </div>
                              )}

                              {this.state.selectedReportType.hasDate
                                ?.quadrimesterSelection && (
                                <div className="row" style={{ marginTop: 18 }}>
                                  <label className="col-3 form-control-label mt-2 content-body required label">
                                    Date Range
                                  </label>
                                  <div className="col-9">
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <DatePicker
                                        views={["month", "year"]}
                                        disableFuture
                                        openTo="month"
                                        value={
                                          this.state.selectedPeriodPickerValue
                                            ? dayjs(this.state.selectedPeriodPickerValue)
                                            : this.state.selectedPeriod
                                            ? dayjs()
                                                .year(
                                                  this.state.selectedPeriod.year
                                                )
                                                .month(
                                                  this.state.selectedPeriod
                                                    .startMonth - 1
                                                )
                                                .date(1)
                                            : null
                                        }
                                        onChange={(newValue) =>
                                          this.handlePeriodChange(newValue)
                                        }
                                        shouldDisableMonth={(date) => {
                                          const m = date.month();
                                          if (m !== 0 && m !== 4 && m !== 8) {
                                            return true;
                                          }
                                          if (
                                            ENABLE_CURRENT_QUADRIMESTER_SELECTION_FOR_TESTING
                                          ) {
                                            return false;
                                          }
                                          const period = quadrimesterForMonth(m + 1);
                                          return period
                                            ? quadrimesterIsStillOpen(
                                                date.year(),
                                                period.endMonth
                                              )
                                            : true;
                                        }}
                                        shouldDisableYear={(yearDate) =>
                                          yearDate.year() < 1970 ||
                                          yearDate.year() > dayjs().year()
                                        }
                                        className="w-100"
                                        minDate={dayjs(
                                          "01-01-1970",
                                          "MM-DD-YYYY"
                                        )}
                                        maxDate={dayjs()}
                                        slots={{
                                          textField: QuadrimesterTextField,
                                        }}
                                        slotProps={{
                                          field: { readOnly: true },
                                          popper: {
                                            sx: {
                                              "& .MuiMonthCalendar-root": {
                                                height: "auto !important",
                                                flexWrap: "nowrap !important",
                                                width: "auto !important",
                                                justifyContent: "center",
                                                columnGap: "12px",
                                              },
                                              "& .MuiPickersLayout-contentWrapper":
                                                {
                                                  height: "auto !important",
                                                },
                                              "& .MuiDateCalendar-root": {
                                                height: "auto !important",
                                                width: "auto !important",
                                              },
                                              "& .MuiDateCalendar-viewTransitionContainer":
                                                {
                                                  minHeight:
                                                    "unset !important",
                                                  height: "auto !important",
                                                },
                                              "& .MuiMonthCalendar-root > *:not(:nth-of-type(1)):not(:nth-of-type(5)):not(:nth-of-type(9))":
                                                {
                                                  display: "none !important",
                                                },
                                              "& .MuiMonthCalendar-root > :nth-of-type(1), & .MuiMonthCalendar-root > :nth-of-type(5), & .MuiMonthCalendar-root > :nth-of-type(9)":
                                                {
                                                  fontSize: "0 !important",
                                                  width: "auto !important",
                                                  minWidth: "96px",
                                                  padding: "0 12px",
                                                  "&::after": {
                                                    fontSize: "0.875rem",
                                                  },
                                                },
                                              "& .MuiMonthCalendar-root > :nth-of-type(1)::after":
                                                {
                                                  content: '"Jan - Apr"',
                                                },
                                              "& .MuiMonthCalendar-root > :nth-of-type(5)::after":
                                                {
                                                  content: '"May - Aug"',
                                                },
                                              "& .MuiMonthCalendar-root > :nth-of-type(9)::after":
                                                {
                                                  content: '"Sep - Dec"',
                                                },
                                            },
                                          },
                                          textField: {
                                            periodLabel:
                                              this.getQuadrimesterFieldLabel(),
                                            size: "small",
                                            error:
                                              this.state.errorMsg.periodErrorText !==
                                              "",
                                            sx: snapshotDateFieldSx,
                                          } as any,
                                        }}
                                      />
                                    </LocalizationProvider>
                                  </div>
                                  {this.state.errorMsg.periodErrorText !== "" &&
                                    showErrorMessage(
                                      this.state.errorMsg.periodErrorText
                                    )}
                                </div>
                              )}

                              <div className="row mt-2">
                                <div className="col-sm-3">
                                  <label className="form-control-label content-body label">
                                    Report Type
                                  </label>
                                </div>
                                <div className="col-sm-5 ">
                                  <RadioGroup
                                    row
                                    aria-label="ReportGenType"
                                    name="ReportGenType"
                                    defaultValue="pdf"
                                    onChange={(event) =>
                                      this.handleReportGenType(event)
                                    }
                                  >
                                    {!this.state.selectedReportType.hasDate
                                      ?.selectionTypeExcelOnly && (
                                      <>
                                        <FormControlLabel
                                          value="pdf"
                                          control={
                                            <Radio
                                              color="primary"
                                              size="small"
                                            />
                                          }
                                          label="PDF"
                                          checked={
                                            this.state.reportGenType == "pdf"
                                              ? true
                                              : false
                                          }
                                        />
                                        <FormControlLabel
                                          value="xls"
                                          control={
                                            <Radio
                                              color="primary"
                                              size="small"
                                            />
                                          }
                                          label="EXCEL"
                                          checked={
                                            this.state.reportGenType == "xls"
                                              ? true
                                              : false
                                          }
                                        />
                                      </>
                                    )}
                                    {this.state.selectedReportType.hasDate
                                      ?.bothSelectionType && (
                                      <FormControlLabel
                                        value="both"
                                        control={
                                          <Radio color="primary" size="small" />
                                        }
                                        label="BOTH"
                                        checked={
                                          this.state.reportGenType == "both"
                                            ? true
                                            : false
                                        }
                                      />
                                    )}
                                    {this.state.selectedReportType.hasDate
                                      ?.selectionTypeExcelOnly && (
                                      <FormControlLabel
                                        value="xls"
                                        control={
                                          <Radio color="primary" size="small" />
                                        }
                                        label="EXCEL"
                                        checked={
                                          this.state.selectedReportType.hasDate
                                            ?.selectionTypeExcelOnly
                                            ? true
                                            : this.state.reportGenType
                                        }
                                      />
                                    )}
                                  </RadioGroup>
                                </div>
                                {this.state.errorMsg.excelReportCheck &&
                                  showErrorMessage(
                                    this.state.errorMsg.excelReportCheck
                                  )}
                                {this.state.selectedReportType.hasDate
                                  ?.sort && (
                                  <>
                                    <div className="col-sm-4" />
                                    <div className="col-sm-3">
                                      <label className="form-control-label content-body label">
                                        Sort By
                                      </label>
                                    </div>
                                    <div className="col-sm-5">
                                      <FormGroup row>
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              color="primary"
                                              checked={
                                                this.state.sortBy.sortBySim
                                              }
                                              onChange={(e) =>
                                                this.handleSort(e, "sortBySim")
                                              }
                                            />
                                          }
                                          label="SIM"
                                        />
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              color="primary"
                                              checked={
                                                this.state.sortBy.sortByAccount
                                              }
                                              onChange={(e) =>
                                                this.handleSort(
                                                  e,
                                                  "sortByAccount"
                                                )
                                              }
                                            />
                                          }
                                          label="ACCOUNT"
                                        />
                                      </FormGroup>
                                    </div>
                                  </>
                                )}
                                <div className="col-sm-4">
                                  <button
                                    type="button"
                                    className="btn btn-submit float-right buttons"
                                    onClick={this.generateReport}
                                  >
                                    Generate Report
                                  </button>
                                </div>
                              </div>

                              <div className="row mt-2">
                                <div
                                  className="col col-12"
                                  id="reportDiv"
                                ></div>
                              </div>
                            </div>
                          </div>
                        </section>
                        <div className="card-body">
                          <div className="table-responsive data-table-wrapper"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <AlertDialogSlide
                show={this.state.isShowingModal}
                handleNo={this.handleChangeForShowingModal}
                title={this.state.selectedReportType?.label}
                negativeButtonTitle="OK"
                icon="true"
              >
                <p className="fields-font">
                  Due to the large amount of data that must be processed, you
                  will be notified via email when the report is complete.{" "}
                  <span className="span"></span>
                </p>
              </AlertDialogSlide>
              <DefaultFooter />
              {this.state.loading && (
                <div className="overlay">
                  <Loader loading={this.state.loading} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Report);
